// @flow
import { useCallback } from 'react';
import { useSelector } from 'react-redux';

import ShapePicker from '../ShapePicker';

import FilterSection from '../catalogFilters/FilterSection';
import FilterTab from '../catalogFilters/FilterTab';
import FilterItems from '../catalogFilters/FilterRadioItems';

import QuestionMarkPopup from '../popups/QuestionMark';
import * as CenterShapeContent from '../popups/content/CenterShape';

import css from '@styles/ringFilters';

const shapeMap = {
  B: 'Round',
  PR: 'Princess-Cut',
  M: 'Marquise',
  H: 'Heart-Shaped',
  O: 'Oval',
  AS: 'Asscher',
  P: 'Pear-Shaped',
  E: 'Emerald-Cut',
  C: 'Cushion-Cut',
  R: 'Radiant-Cut'
};

type TProps = {
  isOpen: boolean,
  onToggle: () => void,
  onFilterChange: (Category: string, Value: string) => void,
  selectedItem: string
};

export default function ShapeFilters ({
  onFilterChange,
  selectedItem,
  isOpen,
  onToggle
}: TProps) {
  const dyorDiamond = useSelector((state) => state.ringBuilder.diamond.data);
  const handleShapeSelection = useCallback(
    (shape) => {
      onFilterChange('shape', shape);
    },
    [onFilterChange]
  );

  return (
    <FilterSection
      className={css.shape}
      enableClickOutside={isOpen}
      onClickOutside={onToggle}>
      <FilterTab
        name="Center Shape"
        className={css.shapeTab}
        showingContent={isOpen}
        onClick={onToggle}
        activeFilterCount={1}
        key="shape-tab"
      />
      <FilterItems
        className={css.shapeContent}
        key="shape-content"
        show={isOpen}>
        <ShapePicker
          onShapeChange={handleShapeSelection}
          selectedShapes={
            dyorDiamond ? [shapeMap[dyorDiamond.shape]] : [selectedItem]
          }
          hiddenShapes={['R']}
          selectableShapes={dyorDiamond ? [dyorDiamond.shape] : undefined}
          showHeader={false}
          incompatibleWord="diamond"
          showCompatibility={false}
        />
        <QuestionMarkPopup
          initialContent={CenterShapeContent}
          style={{ height: 20, width: 20 }}
          containerStyle={{
            position: 'absolute',
            bottom: 14,
            right: 14,
            zIndex: 1
          }}
          doNotScrollToPopup
        />
      </FilterItems>
    </FilterSection>
  );
}
